import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { adminLogin, hrLogin } from '../api/auth';

const ROLES = [
  { value: 'admin', label: 'Admin', path: '/superadmin' },
  { value: 'hr', label: 'HR (Company)', path: '/b2b' },
];

// Console login. Only Admin and HR use this console — employees use the mobile app.
//   Admin -> real Django superuser credentials.
//   HR    -> company HR account (email we set at onboarding + temp password).
export default function Login() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const initialRole = ROLES.some((r) => r.value === params.get('role'))
    ? params.get('role')
    : 'admin';
  const [role, setRole] = useState(initialRole);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const dest = ROLES.find((r) => r.value === role)?.path || '/superadmin';

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    setLoading(true);
    try {
      if (role === 'admin') {
        await adminLogin(username.trim(), password);
      } else {
        await hrLogin(username.trim(), password);
      }
      navigate(dest);
    } catch (err) {
      setError(err.message || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <form className="login-card" onSubmit={handleSubmit}>
        <div className="login-brand">
          <h1>Mashwara</h1>
          <span>B2B Console</span>
        </div>

        <label className="login-label">Login as</label>
        <select
          className="login-input"
          value={role}
          onChange={(e) => {
            setRole(e.target.value);
            setError('');
          }}
        >
          {ROLES.map((r) => (
            <option key={r.value} value={r.value}>
              {r.label}
            </option>
          ))}
        </select>

        <label className="login-label">
          {role === 'hr' ? 'HR Email' : 'Username'}
        </label>
        <input
          className="login-input"
          type="text"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          autoComplete="username"
          placeholder={role === 'hr' ? 'hr@company.com' : ''}
        />

        <label className="login-label">Password</label>
        <input
          className="login-input"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          autoComplete="current-password"
        />

        {error && <div className="login-error">{error}</div>}

        <button
          className="login-btn"
          type="submit"
          disabled={loading || !username || !password}
        >
          {loading ? 'Signing in…' : 'Sign in'}
        </button>
      </form>
    </div>
  );
}
